import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import styles from './fail.module.css';

import { Title } from '../Title';
import { Description } from '../Description';
import { Content } from '../Content';
import { ButtonWithLoader } from '../ButtonWithLoader/ButtonWithLoader';

interface Props {
  isMobile?: boolean;
  onSubmit: () => void;
}

export const Fail: React.FC<Props> = ({ isMobile = false, onSubmit }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = useCallback(async () => {
    setIsSubmitting(true);
    await onSubmit();
    setIsSubmitting(false);
  }, [onSubmit]);

  return (
    <div
      className={classnames({
        [styles.wrapperMobile]: isMobile,
      })}
    >
      <Title>Что-то пошло не так 😞</Title>
      <Description className={styles.description}>
        Возможно, это произошло из-за отсутствия интернет-соединения
      </Description>
      <Content>
        <ButtonWithLoader
          primary
          onClick={handleSubmit}
          isLoading={isSubmitting}
          disabled={isSubmitting}
          width="100%"
        >
          Попробовать снова
        </ButtonWithLoader>
      </Content>
    </div>
  );
};
